import React from "react";
import Header from "./header";
import Navigation from "./navigation";
import Footer from "./footer";
import "./style.css";

const LayoutEssentials = props => (
  <div className="layout-essentials">
    <Header />
    <Navigation {...props} />
    <Footer />
  </div>
);

export default LayoutEssentials;
